import { motion } from "framer-motion";

// Line-by-line masked reveal. Pass an array of lines.
export default function MaskedReveal({ lines, className = "", lineClassName = "", start = 0.35, stagger = 0.12, animate = true }) {
  return (
    <span className={className} aria-label={lines.join(" ")}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden">
          <motion.span
            className={`block ${lineClassName}`}
            initial={{ y: "110%" }}
            {...(animate
              ? { animate: { y: 0 } }
              : { whileInView: { y: 0 }, viewport: { once: true, margin: "-60px" } })}
            transition={{ duration: 0.9, delay: start + i * stagger, ease: [0.22, 1, 0.36, 1] }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}
